import React, { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { BonsaiLogo } from "@/components/BonsaiLogo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-secondary">
      <div className="w-full max-w-md">
        <div className="mb-8 flex justify-center"><BonsaiLogo size={30} /></div>
        <div className="bg-white border border-border rounded-2xl p-8">
          <h2 className="text-2xl font-extrabold text-navy">Recupera password</h2>
          {sent ? (
            <p data-testid="forgot-confirmation" className="text-sm text-muted-foreground mt-4">
              Se l'email e registrata, riceverai un link per reimpostare la password.
            </p>
          ) : (
            <form onSubmit={submit} className="space-y-4 mt-6">
              <div>
                <Label htmlFor="email">Email</Label>
                <Input id="email" type="email" required value={email}
                  data-testid="forgot-email-input"
                  onChange={(e) => setEmail(e.target.value)} className="mt-1.5" />
              </div>
              {error && <p className="text-sm text-destructive">{error}</p>}
              <Button type="submit" disabled={loading} data-testid="forgot-submit-button" className="w-full h-11 font-bold">
                {loading ? "Invio..." : "Invia link"}
              </Button>
            </form>
          )}
          <div className="mt-4 text-center">
            <Link to="/login" className="text-sm text-accent font-semibold hover:underline">
              Torna al login
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
